export interface StructuredQuestion {
  index: number
  question_number: string
  section?: string
  question_type: string
  question: string
  question_details?: string
  options?: string[]
  attachment_required: boolean
  required: boolean
  char_limit?: number
  word_limit?: number
  conditional_on?: ConditionalDisplay
  depends_on?: QuestionDependency
  has_other_text_field?: boolean
}

export interface ConditionalDisplay {
  question_number?: string
  operator?: string // equals, not_equals, contains, any_of
  value?: string
}

export interface QuestionDependency {
  question_numbers?: string[]
}

export interface QuestionFormaterResponse {
  questions: StructuredQuestion[]
  raw_text: string
  confidence: string
  parsing_notes: string
  ambiguities?: string[]
  warnings?: string[]
}

// A single matched pair (or addition/removal) from the backend fuzzy question matching
export interface QuestionMatchResult {
  existing?: StructuredQuestion // stored DB version (absent if status = 'added')
  extracted?: StructuredQuestion // newly parsed version (absent if status = 'removed')
  status: 'matched_unchanged' | 'matched_changed' | 'added' | 'removed'
  similarity: number // text similarity score 0–1 (0 for added/removed)
  changed_fields: string[] // field names that differ on matched_changed pairs
}

// Tracks the editable result state for a single row in the diff view
export interface DiffRowResult {
  question: StructuredQuestion // the current result value (editable by admin)
  included: boolean // whether to include in final output
  source: 'existing' | 'extracted' | 'edited' // tracks which version the result started from
}

// Response from POST /{opportunity_uuid}/questions/extract-and-compare
export interface QuestionDiffResponse {
  extracted_text: string
  parsed_questions: StructuredQuestion[] // all extracted questions (for import flow)
  existing_questions: StructuredQuestion[] // all stored questions
  matches: QuestionMatchResult[] | null // fuzzy-matched pairs; null if no existing questions
  has_existing_questions: boolean
  confidence: string
  parsing_notes: string
  ambiguities?: string[]
  warnings?: string[]
}

export const QUESTION_TYPES = [
  { value: 'text', label: 'Short Text' },
  { value: 'textarea', label: 'Long Text (Paragraph)' },
  { value: 'single_choice', label: 'Single Choice' },
  { value: 'multi_choice', label: 'Multiple Choice' },
  { value: 'yes_no', label: 'Yes/No' },
  { value: 'file_upload', label: 'File Upload' },
]
export const CONDITIONAL_OPPERATORS = [
  { value: 'equals', label: 'Equals' },
  { value: 'not_equals', label: 'Does not equal' },
  { value: 'contains', label: 'Contains' },
  { value: 'any_of', label: 'Any of' },
]
